/* eslint-disable id-length, default-case */
import { useEffect } from 'react';
import { useKeyboard } from 'react-aria';

interface Props {
  autoFocus?: boolean;
  onNext?: () => void;
  onPrev?: () => void;
  onToggle?: () => void;
  ref?: React.RefObject<HTMLElement>;
}

export function useKeyboardNav({
  autoFocus = false,
  onNext,
  onPrev,
  onToggle,
  ref,
}: Props) {
  const { keyboardProps } = useKeyboard({
    onKeyDown: (e) => {
      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault();
          onPrev?.();
          break;
        case 'ArrowDown':
          e.preventDefault();
          onNext?.();
          break;
        case ' ':
          e.preventDefault();
          onToggle?.();
      }
    },
  });

  useEffect(() => {
    if (autoFocus) {
      ref?.current?.focus();
    }
    // NOTE: autoFocus behaviour is only applicable when the component is first
    // mounted and rendered. So ignore this effects dependency list to run it just
    // once on load.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { keyboardProps };
}
